
import { useState, useEffect } from "react";

const MOBILE_BREAKPOINT = 768;

export function useIsMobile() {
  // Start with a definite value of false
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // Define the check function
    const checkIfMobile = () => {
      const isMobileView = window.innerWidth < MOBILE_BREAKPOINT;
      setIsMobile(isMobileView);
    };
    
    // Run immediately
    checkIfMobile();
    
    // Add event listener with throttling to improve performance
    let timeoutId: number | null = null;
    const handleResize = () => {
      if (timeoutId) {
        window.clearTimeout(timeoutId);
      }
      timeoutId = window.setTimeout(checkIfMobile, 100);
    };
    
    window.addEventListener("resize", handleResize);
    
    // Clean up
    return () => {
      if (timeoutId) {
        window.clearTimeout(timeoutId);
      }
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return isMobile;
}
